/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import Container from 'components/Container';
import useLocalizationContext from 'hooks/useLocalizationContext';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { RouteOptions, routeUrl } from 'routesBuilder';
import { PressArticle } from 'types/PressReleasesData';

export interface PressReleaseNewsProps extends React.HTMLAttributes<HTMLDivElement> {
  pressNews: PressArticle[];
  pressReleases: PressArticle[];
}

const PressReleaseNews: React.FC<PressReleaseNewsProps> = ({ pressReleases, pressNews }) => {
  return (
    <ClassNames>
      {({ theme }) => (
        <Container maxWidth='lg'>
          <div
            css={{
              '@media (min-width: 425px)': {},
              '@media (min-width: 600px)': {},
              alignItems: 'flex-start',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              justifyContent: 'flex-start',
              padding: theme.spacing(4, 0),
            }}
          >
            <div css={{ marginBottom: theme.spacing(2) }}>
              <FormattedMessage id={'pressrelease.text1'} />
            </div>
            {(pressReleases || []).map((a, idx) => (
              <PressReleaseNewsArticle path='pressDetail' key={idx.toString()} article={a} />
            ))}
            <div css={{ margin: theme.spacing(2, 0) }}>
              <FormattedMessage id={'pressrelease.text2'} />
            </div>
            {(pressNews || []).map((a, idx) => (
              <PressReleaseNewsArticle path='pressNewDetail' key={idx.toString()} article={a} />
            ))}
          </div>
        </Container>
      )}
    </ClassNames>
  );
};

export default PressReleaseNews;

const PressReleaseNewsArticle: React.FC<{ article: PressArticle; path: RouteOptions }> = ({ article, path }) => {
  const { locale, region } = useLocalizationContext();
  return (
    <ClassNames>
      {({ theme }) => (
        <Link
          css={{
            '&:hover': {
              background: theme.palette.divider,
            },
            '&:not(:last-of-type)': {
              borderBottom: '1px solid',
              borderBottomColor: theme.palette.divider,
            },
            alignItems: 'flex-start',
            color: theme.palette.text.primary,
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(1, 2),
            textDecoration: 'none',
            transition: 'all .2s ease',
            width: '100%',
          }}
          to={routeUrl(path, { locale, params: { id: article.path, locale: locale, region: region } })}
        >
          <span css={{ fontWeight: theme.typography.fontWeightMedium }}>{article.title}</span>
          <span css={{ ...theme.typography.caption }}>{article.teaserText}</span>
        </Link>
      )}
    </ClassNames>
  );
};
